import useTranslation from '../../hooks/use-translation/use-translation';
import {UserSettings} from '../../utils/typescript-types/userSettings';
import ProductPrice from '../product-price/product-price';
import Rating from '../rating/rating';
import {P} from '../typography/typography';
import './product-summary.scss';
import {StyledRatingLine} from './styles';

const ProductSummary = ({item, settings, customerProductData, pdpExp}: propTypes) => {
  const MAX_VISIBLE_CATEGORY_DEPTH = 99;
  const {t} = useTranslation();

  const categoryUrl = () =>
    item.categories.reduce(
      (a, x) => (x.depth > a.depth && x.depth < MAX_VISIBLE_CATEGORY_DEPTH ? x : a),
      {
        depth: -Infinity,
      },
    ).relative_path;

  return (
    <>
      <h1>
        <span className="title">{`${item.name}${
          item.year_made ? ` (${item.year_made}) ` : ' '
        }`}</span>
        <span className="subtitle">
          {item.categories ? (
            <a href={categoryUrl()}>{item.category_full_name}</a>
          ) : (
            item.category_full_name
          )}
          <br />
          {' by '}
          <a href={`/artist/${item.artist_slug}/`}>{item.artist_name}</a>
        </span>
      </h1>

      {item.review_count > 0 && (
        <StyledRatingLine>
          <Rating value={item.summary_seller_rating} size="16px" />{' '}
          <span>{t('{review_count} Artist Reviews', item)}</span>
        </StyledRatingLine>
      )}

      <ProductPrice item={item} settings={settings} customerProductData={customerProductData} />

      {pdpExp !== 'urg' && item.in_sale && item.is_in_stock && (
        <P style="p1" color="accent">
          {item.discount_amount}
          {t('% off sale. Sale ends in')} {item.sale_ends_in}
        </P>
      )}
    </>
  );
};

interface propTypes {
  item: any;
  settings: UserSettings;
  customerProductData?: any;
  pdpExp?: any;
}

export default ProductSummary;
